// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2thba","title":"Info_title__nrqJp","selects":"Info_selects__3LI4E","requiredAsterisk":"Info_requiredAsterisk__1LdbC"};